<template>
  <div class="pa-5">
    <v-skeleton-loader
      class="mx-auto"
      v-if="!forms"
      type="list-item-avatar, divider, list-item-three-line, card-heading, image, actions"
    ></v-skeleton-loader>
    <v-card shaped class="elevation-10" v-else>
      <v-card-title>
        <div>รายการแบบฟอร์ม</div>
        <v-spacer></v-spacer>
        <v-btn color="success" to="/form/create">เพิ่มแบบฟอร์ม</v-btn>
      </v-card-title>
      <v-card-text class="py-0">
        <v-row>
          <v-col md="6">
            <v-select 
              dense 
              solo 
              :items="form_groups" 
              item-text="name_th" 
              item-value="id" 
              label="หมวดหมู่"
              @change="type_change"
            ></v-select>
          </v-col>
          <v-col md="6">
            <v-text-field v-model="term" dense solo prepend-inner-icon="mdi-magnify" label="ค้นหา" @input="searchChange"></v-text-field>
          </v-col>
        </v-row>    
      </v-card-text>
      <v-simple-table>
        <template v-slot:default>
          <thead>
            <tr>
              <th style="width: 15%;">หมวดหมู่</th>
              <th style="width: 80%;">ชื่อแบบฟอร์ม</th>
              <th style="width: 5%;"></th>
            </tr>
          </thead>
          <tbody v-if="forms.data.length > 0">
            <tr v-for="item in forms.data" :key="item.id">
              <td class="text-truncate">{{ item.form_group.name_th }}</td>
              <td>{{ item.name }}</td>
              <td>
                <v-menu offset-y transition="fade-transition">
                  <template v-slot:activator="{ on, attrs }">
                    <v-btn icon v-on="on" v-bind="attrs"><v-icon>mdi-dots-vertical</v-icon></v-btn>
                  </template>
                  <v-list>
                    <v-list-item :to="`/form/${item.id}/edit`">
                      <v-list-item-icon><v-icon>mdi-pencil</v-icon></v-list-item-icon>
                      <v-list-item-title>แก้ไข</v-list-item-title>
                    </v-list-item>
                    <v-list-item @click="confirmDeleteForm(item.id)">
                      <v-list-item-icon><v-icon>mdi-delete</v-icon></v-list-item-icon>
                      <v-list-item-title>ลบ</v-list-item-title>
                    </v-list-item>
                  </v-list>
                </v-menu>
              </td>
            </tr>
          </tbody>
          <tbody v-else>
            <v-subheader>---ไม่พบแบบฟอร์มในระบบ---</v-subheader>
          </tbody>
        </template>
      </v-simple-table>
      <v-pagination
        class="pb-5"
        v-model="page"
        :length="forms.last_page"
        @input="selectPage"
      ></v-pagination>
    </v-card>
    <v-dialog v-model="confirm_delete" max-width="500">
      <v-card>
        <v-card-title>ยืนยันการลบแบบฟอร์ม</v-card-title>
        <v-card-text>คุณต้องการลบแบบฟอร์มนี้ใช่หรือไม่</v-card-text>
        <v-card-actions>
          <v-btn color="error" @click="deleteForm()">ยืนยัน</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
import _ from 'lodash';

export default {
  data: () => ({
    page: 1,
    term: '',
    type: '',
    forms: null,
    confirm_delete: false
  }),
  computed: {
    form_groups() { 
      return [ { id: '', name_th: 'ทั้งหมด' }, ...this.$store.state.form.form_groups ]
    }
  },
  created() {
    this.getForm('', '', this.page);
  },
  methods: {
    getForm(term, type, page) {
      this.$store.dispatch('form/list', {
        term: term,
        type: type,
        page: page
      }).then(data => this.forms = data);
    },
    deleteForm() {
      this.$store.dispatch('form/delete', this.delete_selected).then(() => {
        this.getForm('', '', 1);
        this.confirm_delete = false;
        this.$store.commit('SHOW_SNACKBAR', {
          color: 'success',
          message: 'ลบข้อมูลสำเร็จ'
        });
      });
    },
    confirmDeleteForm(id) {
      this.confirm_delete = true;
      this.delete_selected = id;
    },
    selectPage(e) {
      this.page = e;
      this.getForm(this.term, this.type, e);
    },
    type_change(val) {
      this.type = val;
      this.getForm(this.term, val, 1);
    },
    searchChange: _.debounce(function(e) {
      this.page = 1;
			this.getForm(e, this.type, 1);
		}, 500),
  }
}
</script>